import { useRouter } from 'next/router';
import { SignUpVerification as View, toast } from 'ui-components';

import { useResendEmail } from '~auth/queries/useResendEmail';

export const SignUpVerification = () => {
	const {
		query: { email },
	} = useRouter();

	const resendEmail = useResendEmail();

	const onResendEmail = () => {
		toast.promise(
			async () => {
				await resendEmail.mutateAsync({ email: email as string });
			},
			{
				loading: 'Sending email...',
				success: 'Email sent!',
				error: 'Failed to send email',
			}
		);
	};

	return <View email={email as string} onResendEmail={onResendEmail} />;
};
